import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Img } from "components";
import FieldRenderer, { IFieldProps } from '../fieldRenderer';

interface ExtraFieldsSectionProps {
  extraFields: IFieldProps[];
  files: { [key: string]: File };
  setFiles: React.Dispatch<React.SetStateAction<{ [key: string]: File }>>;
  fileBinaries: { [key: string]: string };
  setFileBinaries: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
  extraFieldValues: { [key: string]: string };
  setExtraFieldValues: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
}

const ExtraFieldsSection: React.FC<ExtraFieldsSectionProps> = ({
  extraFields,
  files,
  setFiles,
  fileBinaries,
  setFileBinaries,
  extraFieldValues,
  setExtraFieldValues,
}) => {
  if (extraFields.length === 0) return null;

  return (
    <Accordion
      type="single"
      collapsible
      defaultValue="item-1"
      className="w-full relative right-10"
    >
      <AccordionItem className="border-none" value="item-1">
        <AccordionTrigger className="bg-[#F9F9F9] rounded-xl border-none px-5">
          <div className="flex justify-between">
            <div className="flex gap-2 items-center">
              <div>
                <Img src="/images/remit/beni.svg" alt="" />
              </div>
              <div>Mandatory details</div>
            </div>
          </div>
        </AccordionTrigger>
        <AccordionContent className="flex flex-col mt-5 pl-10 gap-10 sm:w-full w-1/2">
          <div className="flex flex-col gap-5">
            {extraFields.map((field, index) => (
              <FieldRenderer
                key={field.name}
                fileBinaries={fileBinaries}
                extraFieldValues={extraFieldValues}
                setFileBinaries={setFileBinaries}
                setExtraFieldValues={setExtraFieldValues}
                isLast={index === extraFields.length - 1}
                field={field}
                files={files}
                setFiles={setFiles}
              />
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default ExtraFieldsSection;